<template>
  <div>
    <title>销售员注册审核</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <CompanyTab></CompanyTab>
      <!--E 公用头部切换-->
      <!--S 检索-->      
      <el-form inline :model="searchForm" class="searchForm">
        <el-form-item label="关键词">
          <el-input v-model="searchForm.flowname" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="支局（单位）名称">
          <el-input v-model="searchForm.idnumber" placeholder="请输入支局（单位）名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" class="formTimeSlot">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="禁用" :value="0"></el-option>
            <el-option label="启用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySalesMan">查询</el-button>
          <!-- <el-button type="primary" plain v-show="!batchExamine" @click="getExamineBox(2)">批量审核</el-button>
          <el-button type="danger" v-show="batchExamine" icon="el-icon-close" round @click="examineCancel(0)">取消</el-button>
          <el-button type="success" v-show="batchExamine" icon="el-icon-check" round @click="examineCancel(1)">确定</el-button> -->
        </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <el-table class="comTable orderTable" ref="gsTable" :data="salesManData" border :maxHeight="tableHeight" v-loading="isLoad">
        <!-- <el-table-column type="selection" v-if="batchExamine" :key="1" width="80"></el-table-column> -->
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <!-- <el-table-column label="所属总代理" min-width="200" sortable prop="pflowname">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.pflowname">{{scope.row.pflowname || '--'}}</p>
          </template>
        </el-table-column> -->
        <el-table-column label="申请人" min-width="280">
          <template slot-scope="scope">
            <dl class="pdr70 linkNum">
              <dt class="iconuser textFl" :title="scope.row.flowname">{{scope.row.flowname}} 
                <el-tag v-if="scope.row.status==0" type="danger" plain>已禁用</el-tag>
              </dt>
              <dd class="flexUI">
                <span v-if="scope.row.mobile" class="iconiPhone" :title="'手机号码：'+scope.row.mobile">{{scope.row.mobile}}</span>
                <span v-if="scope.row.idnumber" class="icongh" :title="'支局（单位）名称：'+scope.row.idnumber">{{scope.row.idnumber}}</span>
              </dd>
            </dl>
          </template>
        </el-table-column>
        <el-table-column label="单位地址" min-width="280">
          <template slot-scope="scope">
            <div v-if="scope.row.province || scope.row.city || scope.row.city || scope.row.addrdet">
              <p>{{scope.row.province}}&nbsp;{{scope.row.city}}&nbsp;{{scope.row.district}}</p>
              <small v-if="scope.row.addrdet" class="textFl pdr70" :title="scope.row.addrdet">{{scope.row.addrdet}}</small>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像/昵称" min-width="280">
          <template slot-scope="scope">
            <div class="flexUpDownCenter wechatAvatar" v-if="scope.row.hpurl || scope.row.nickname">
              <p><img class="imgAlign" :src="scope.row.hpurl ? scope.row.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></p>
              <span>{{scope.row.nickname}}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <p class="handle">
                <span @click="getExamineBox(0,scope.row.flowcode)"><i class="icondetails"></i></span>
                <span @click="getExamineBox(1,scope.row.flowcode)"><i class="iconsh"></i></span>
              </p>
            </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->

     <!-- S 销售员审核 -->
     <el-dialog class="comDlog examineDlg" :title="operateType==1?'审核':(operateType==2?'批量审核':'详情')" :visible.sync="examineShow" append-to-body :close-on-click-modal="false">
        <el-form :model="examineForm" ref="examineForm" :rules="examineRules" label-width="200px">
          <!--S 销售员详情-->
          <template v-if="operateType!==2">
            <el-form-item label="申请人：" class="noformitem allWidth">
              <el-tag v-if="applicantInfo.status==0" type="danger" plain>已禁用</el-tag>
              {{applicantInfo.flowname?applicantInfo.flowname:'匿名申请人'}}
            </el-form-item>
            <el-form-item label="手机号码：" class="noformitem allWidth">{{applicantInfo.mobile?applicantInfo.mobile:'--'}}</el-form-item>
            <el-form-item label="支局（单位）名称：" class="noformitem allWidth">{{applicantInfo.idnumber?applicantInfo.idnumber:'--'}}</el-form-item>
            <el-form-item label="单位地址：" class="noformitem allWidth" v-if="applicantInfo.province || applicantInfo.city || applicantInfo.district || applicantInfo.addrdet">{{applicantInfo.province}} {{applicantInfo.city}} {{applicantInfo.district}} {{applicantInfo.addrdet}}</el-form-item>
            <el-form-item label="所属总代理：" class="noformitem allWidth">{{applicantInfo.pflowname?applicantInfo.pflowname:'--'}}</el-form-item>
            <el-form-item label="微信：" class="noformitem flexItem allWidth" v-if="applicantInfo.hpurl || applicantInfo.nickname">
              <span class="wxLogo"><img class="imgCenter" :src="applicantInfo.hpurl?applicantInfo.hpurl:'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></span>
              <p>{{applicantInfo.nickname}}</p>
            </el-form-item>
          </template>
          <!--E 销售员详情-->
          <!--S 审核-->
          <template v-if="operateType!==0">
          <el-form-item label="审核状态：">
            <el-radio-group v-model="examineForm.status">
              <el-radio label="0">审核通过</el-radio>
              <el-radio label="1">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注：" prop="memo" v-if="examineForm.status=='1'">
            <el-input type="textarea" v-model="examineForm.memo" :autosize="{ minRows: 5, maxRows: 10}" maxlength="50" show-word-limit placeholder="请填写审核备注" ></el-input>
          </el-form-item>
          </template>
          <!--E 审核-->
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="operateType!==0">
          <el-button type="primary" @click="closeExamineBox(1)">确定</el-button>
				  <el-button @click="closeExamineBox(0)">取消</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button type="primary" @click="closeExamineBox(0)">关闭</el-button>
        </div>
     </el-dialog>
     <!-- E 销售员审核 -->
     
    </section>
  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'SalesmanExamine',
  data () {
    return {
      isLoad:false,//加载中
      searchForm: {
        flowname: "",  
        mobile:'',
        idnumber:'',
        status:1,
      },//检索
      salesManData:[],//销售人员列表
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean:{
        totalnum: 0,
      }, // 列表分页信息
      multipleSelection: [], //已选中的销售员
      tableHeight: window.innerHeight*.8, //表格动态高度
      operateType:'',//操作，0:详情， 1:审核，2：批量审核
      batchExamine:false,//批量审核
      examineShow:false,//审核弹框
      curFlowCode:'',//当前销售员编号
      applicantInfo:{},//申请人详情
      examineForm:{ //审核表单
        status:'0',
        memo:'',
      },
      examineRules:{
        memo:[{required:true,message:'审核不通过的备注不能为空'}],//审核不通过备注
      },
      userInfoMd:{},//门店登录信息
    }
  },
  filters:{
    //审核状态过滤
    examineStatusFilter(val){
      if(val== 0){
        return '待审核'
      }else if(val==1){
        return '审核通过'
      }else if(val==2){
        return '审核不通过'
      }
    },
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
  },
  methods: {
    //查询待审核销售
    querySalesMan(){
      this.currentPage = 1;
      this.getSalesManList();
    },
    //获取销售人员列表
    getSalesManList(){
      let params = {
        isapply:1,
        pflowcode:this.userInfoMd.flowcode,
        flowname:this.searchForm.flowname,
        mobile:this.searchForm.mobile,
        idnumber:this.searchForm.idnumber,
        status:this.searchForm.status,
        objtype:'4',  //0:门店；1：发货网点；2：一级分销；4：微门店；5.企业微门店；
        examinestatus:0, //审核状态 0：待审核；1：通过；3：不通过
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      this.isLoad = true;
      api.GET_FLOWLIST(params).then((res) =>{
        if(res.data.status == '200'){
          this.isLoad = false;
          this.salesManData = res.data.data;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean
          }
        }else{
          Message({
            message:res.data.message,
            type:'error'
          })
        }
      })
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.getSalesManList();
    },
    //表格多选选中行复制
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //获取销售员详情
    getSalesManDetail(flowcode){
      api.GET_FLOWDETAIL({flowcode:flowcode}).then(res => {
        if(res.data.status == "200" &&res.data.data) {
          this.applicantInfo = res.data.data;
        }else{
          this.$message.error('获取销售员详情信息失败！')
        }
      })
    },
    //审核弹窗
    getExamineBox(val,flowcode){
      this.operateType = val;
      this.curFlowCode = flowcode;
      if(val==2){ //批量审核
        this.batchExamine = true;
      }else{
        this.examineShow = true;
        this.getSalesManDetail(flowcode);
      }
    },
    //确定审核关闭
    closeExamineBox(val){
      if(val){
        this.batchExamine = false;
        this.$refs['examineForm'].validate((valid) => {
          if(valid){
            let params = {
              flowcode:this.curFlowCode,
              status:Number(this.examineForm.status),
              memo:this.examineForm.memo
            }
            api.GET_EXAMINESALESMAN(params).then(res =>{
              if(res.data.status=='200'){
                this.$message.success('审核成功');
                // this.emptyForm();
                this.$refs.examineForm.resetFields();
                this.examineShow = false;
                this.examineForm  = { //审核表单
                  status:'0',
                  memo:'',
                }
                this.getSalesManList();// 更新销售员列表
              }else{
                this.$message.error(res.data.message)
              }
            })
          }else{
            return false;
          }
        })
      }else{
        // this.emptyForm(); 
        if(this.operateType==1){
          this.$refs.examineForm.resetFields();      
          this.examineForm  = { //审核表单
            status:'0',
            memo:'',
          }
        }
        this.examineShow = false;
      }
    },
    //清空审核表单
    emptyForm(){
      this.$refs.examineForm.resetFields();
      this.examineShow = false;
      this.examineForm  = { //审核表单
        status:'0',
        memo:'',
      }
    },
    //是否取消批量审核
    examineCancel(val){
      if(val==1){
        if(this.multipleSelection.length > 0){ //勾选
            this.examineShow = true;
        }else{ //未勾选
          MessageBox.alert('请至少勾选一项！', '系统提示', {
            confirmButtonText: '确定',
            type:'warning',
          });
        }
      }else{
        this.batchExamine = false;
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    if(localStorage.getItem('userInfoMd')) {
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd')); 
      if(this.userInfoMd.flowcode) {
        this.getSalesManList();//获取销售员列表
      }
    }
    
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200)
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.searchForm {padding-top:64px;}
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70 {display:block;padding-right:70px;max-width: calc(100% - 70px);}
.wechatAvatar p{ width:50px; height:50px; border: solid 1px #dcdfe6; border-radius: 100%; margin-right: 10px; position:relative; }
.wechatAvatar p img{ border-radius:100%; }
.wechatAvatar span{ display:inline-block; width: calc(100% - 65px); }
.textFl.iconuser {font-size: 14px;}
.linkNum .iconiPhone {padding-right:20px;}
.linkNum dd {white-space: nowrap;}
.linkNum [class^="icon"]:before {padding-right:5px; font-size: 16px;}
/*审核弹窗 start*/
.examineDlg>>>.el-dialog{width:700px; min-height: 350px;}
.examineDlg >>> .el-form-item:not(.allWidth) .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.examineDlg >>> .el-form-item__content .el-input,
.examineDlg >>> .el-form-item__content .el-radio-group {width:100%;}
.examineDlg >>> .el-form-item.noformitem {margin-bottom:10px;}
.noformitem >>> .el-form-item__label {line-height:20px;padding:5px 12px 5px 0;}
.noformitem >>> .el-form-item__content {line-height:20px;padding:5px 0;}
.noformitem >>> .el-tag{margin-right:5px;}
.flexItem >>> .el-form-item__content {display: -webkit-flex;display: flex;align-items: center;}
.flexItem .wxLogo {position:relative;display:inline-block; width:35px; height:35px;margin-right:10px; border-radius:17.5px; overflow:hidden;border:solid 1px #ebeef5;}
.flexItem .wxLogo + p {flex:1;max-width: calc(100% - 47px);}
/*审核弹窗 end*/
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/SalesmanExamine.vue